'use client';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { getTotalInfoMessage } from '@/lib/tax';
import { MESSAGE_KEY_MAP } from './taxMessageKeys';
import styles from './TaxInfoText.module.scss';

interface TaxInfoTextProps {
  countryCode: string;
  taxCalculated?: boolean;
  hasShippingAddress?: boolean;
  className?: string;
}

/**
 * Localized tax info text displayed under the order Total.
 * Shows "VAT included", "Excl. Sales Tax", etc. based on country.
 * Returns null for no-tax countries (HK, KW, QA).
 */
export const TaxInfoText = ({
  countryCode,
  taxCalculated,
  hasShippingAddress,
  className,
}: TaxInfoTextProps) => {
  const t = useTranslations('price');
  const messageKey = getTotalInfoMessage(countryCode, { taxCalculated, hasShippingAddress });

  if (!messageKey) return null;

  const translationKey = MESSAGE_KEY_MAP[messageKey];
  if (!translationKey) return null;

  return <span className={clsx(styles.info, className)}>{t(translationKey)}</span>;
};
